<template>
  <blank-view>
    <div slot="action" style="display: flex; align-items: center; justify-content: space-between">
      <div>
        <a-button style="margin-right: 8px" @click="exportWorkRecord">{{
          $t('page_ops_work_record_export')
        }}</a-button>
      </div>
      <div>
        <div class="flex status-choose">
          <a-button style="margin-right: 8px" @click="toggleSearch" class="heightSearch">
            {{ $t('page_my_document_advanced') }}
          </a-button>
          <a-input-search
            :placeholder="$t('common_please_input') + $t('keyword')"
            :enterButton="$t('search')"
            allowClear
            style="width: 300px"
            v-model="filter.keywords"
            @search="keywordSearch"
          />
        </div>
      </div>
    </div>
    <div style="display: flex; flex-wrap: nowrap; height: 100%">
      <div id="table-list" class="custom-list">
        <ml-table
          :rowSelection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange
          }"
          :columns="columns"
          :dataSource="dataSource"
          :canChangeColWidth="false"
          rowKey="id"
          :scroll="{ y: scrollY }"
          :selectRowKey="selectedRow && selectedRow.id"
          :customRow="
            (row) => ({
              on: {
                click: () => {
                  this.clickRow(row)
                }
              }
            })
          "
        >
        </ml-table>
        <a-pagination
          size="small"
          style="position: absolute; bottom: 8px; right: 8px"
          :show-total="(total) => `${showTotal(total)}`"
          :current="pagination.current"
          :pageSize="pagination.pageSize"
          :total="pagination.total"
          @change="handleTableChange"
        />
      </div>
      <div class="custom-detail">
        <!-- <div v-if="!selectedRow.id" class="exception">
          <a-empty :image="simpleImage" />
        </div>
        <detail v-else :work-record-id="selectedRow.id"
        ></detail> -->
        <detail :work-record-id="selectedRow.id" :is-history="true"></detail>
      </div>
    </div>

    <advance-search
      :sub-title="$t('page_ops_record_history')"
      :visible="advanceVisible"
      :formData="filter.advance"
      @close="closeToggleSearch"
      @advanceSearch="startToggleSearch"
      @reset="resetSearch"
    ></advance-search>
  </blank-view>
</template>

<script>
import { Empty } from 'ant-design-vue'
import dayjs from 'dayjs'
import { WorkRecordServiceProxy } from '@/service-proxies/app-v2/work-record.service-proxies'
const wrsp = new WorkRecordServiceProxy()

import { exportWorkRecord } from '@/api/api'

import AdvanceSearch from '../common/components/advanceSearch'
import Detail from '../common/components/detail.vue'

export default {
  components: { AdvanceSearch, Detail },
  data() {
    return {
      selectedRow: {}, // 编辑数据
      chooseCustomerId: '',
      total: 0,
      advanceVisible: false,
      selectedRowKeys: [],
      filter: {
        // 查询条件
        size: 15,
        current: 1,
        keywords: '',
        // 0表示已完成
        status: ['0'],
        advance: {
          areaId: undefined,
          areaName: '',
          regionName: '',
          submitUserId: undefined,
          request: '',
          contactUserName: '',
          deviceTypeIds: [],
          time: [],
          startTime: '',
          endTime: '',
          questionDescription: '',
          customerId: undefined,
          provinceId: undefined,
          provinceName: '',
          cityId: undefined,
          cityName: '',
          isInvolvedMachine: '',
          workStationId: undefined,
          claimUser: undefined
        }
      },
      isAdvance: false,
      columns: [
        {
          title: this.$t('page_ops_work_record_document_number'),
          dataIndex: 'code',
          key: 'code',
          ellipsis: true,
          width: 110
        },
        {
          title: this.$t('page_ops_work_record_customer_name'),
          dataIndex: 'customerName',
          key: 'customerName',
          ellipsis: true
        },
        {
          title: this.$t('page_ops_work_record_submit_time'),
          dataIndex: 'submitTime',
          key: 'submitTime',
          customRender: (t) => {
            return dayjs(t).format('YYYY-MM-DD HH:mm:ss') || ''
          },
          width: 170
        },
        {
          title: this.$t('page_ops_work_record_handle_time'),
          dataIndex: 'updateTime',
          key: 'updateTime',
          customRender: (t) => {
            return dayjs(t).format('YYYY-MM-DD HH:mm:ss') || ''
          },
          width: 170
        }
      ],
      dataSource: [],
      dictList: [],
      pagination: {
        total: 0,
        pageSize: 20,
        current: 1
      },
      scrollY: 0
    }
  },
  watch: {
    '$route.query': {
      handler(v){
        this.filter.keywords = v.keyWord || ''
      },
      immediate: true,
      deep: true
    }
  },
  beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE
  },
  async created() {
    this.getData()
  },
  methods: {
    getParams() {
      const params = {
        processProgress: this.filter.status,
        idList: this.selectedRowKeys,
        keyValue: this.filter.keywords,
        questionDesc: this.filter.advance.request,
        areaName: this.filter.advance.areaName,
        startTime: this.filter.advance.startTime,
        endTime: this.filter.advance.endTime,
        submitUserId: this.filter.advance.submitUserId,
        deviceTypeIds: this.filter.advance.deviceTypeIds,
        contactUserName: this.filter.advance.contactUserName,
        isAdvance: this.isAdvance,
        customerId: this.filter.advance.customerId,
        provinceName: this.filter.advance.provinceName,
        cityName: this.filter.advance.cityName,
        claimUser: this.filter.advance.claimUser,
        isInvolvedMachine: this.filter.advance.isInvolvedMachine,
        workstationId: this.filter.advance.workStationId
      }
      return params;
    },
    showTotal(total) {
      return this.$t('Total…items').replace('{0}', total)
    },
    handleTableChange(current) {
      this.pagination.current = current
      if (!this.isAdvance) {
        this.getData()
      } else {
        this.advanceSearch()
      }
    },
    keywordSearch() {
      this.pagination.current = 1
      this.isAdvance = false;
      this.getData()
    },
    resetSearch() {
      this.filter.advance = {
        areaId: undefined,
        areaName: '',
        regionName: '',
        submitUserId: undefined,
        request: '',
        contactUserName: '',
        deviceTypeIds: [],
        time: [],
        startTime: '',
        endTime: '',
        questionDescription: '',
        customerId: undefined,
        provinceId: undefined,
        provinceName: '',
        cityId: undefined,
        cityName: '',
        claimUser: undefined,
        isInvolvedMachine: '',
        workStationId: undefined
      }
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    toggleSearch() {
      this.advanceVisible = !this.advanceVisible
    },
    closeToggleSearch() {
      this.advanceVisible = false
    },
    startToggleSearch(value) {
      this.filter.keywords = ''
      this.filter.advance = value
      this.isAdvance = true
      this.pagination.current = 1
      this.advanceSearch()
    },
    advanceSearch() {
      const params = this.getParams();
      wrsp
        .getWorkRecordList(
          this.pagination.current,
          params,
          this.pagination.pageSize
        )
        .then((res) => {
          this.pagination.total = res.total
          this.dataSource = res.records
          if(!res.records.length) {
            this.selectedRow = {}
          } else {
            this.selectedRow = this.dataSource[0]
          }
          this.setScroll(res)
        })
    },
    getData() {
      let temp = this.selectedRow
      this.selectedRow = {}
      wrsp
        .getWorkRecordListByFuzzySearch(
          {
            keyValue: this.filter.keywords,
            processProgress: this.filter.status
          },
          this.pagination.current,
          this.pagination.pageSize
        )
        .then((res) => {
          this.isAdvance = false
          if (res.records.length) {
            this.pagination.total = res.total
            this.dataSource = res.records
            this.selectedRow = res.records[0]
          } else {
            this.dataSource = []
            this.selectedRow = {}
            this.pagination.total = 0
          }
          this.setScroll(res)
        })
    },
    setScroll(data) {
      const dev = document.getElementById('table-list')
      if (dev) {
        const height = dev.clientHeight - 80
        if (height < data.records.length * 33) {
          this.scrollY = height
        } else {
          this.scrollY = 0
        }
      }
    },
    clickRow(row) {
      this.selectedRow = row
      this.selectedRowId = row.id
      this.selectedRowKeys = [row.id]
    },
    exportWorkRecord() {
      const params = this.getParams();
      exportWorkRecord(params).then((res) => {
        // 创建隐藏的可下载链接
        var a = document.createElement('a')
        a.download = `${this.$t('page_ops_record_history')}.xlsx`
        a.style.display = 'none'
        // 字符内容转变成blob地址
        let url = URL.createObjectURL(res)
        a.href = url
        // 触发点击
        document.body.appendChild(a)
        a.click()
        // 然后移除
        URL.revokeObjectURL(url)
        document.body.removeChild(a)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.exception {
  width: 100%;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.custom-list {
  width: 700px;
  position: relative;
}
.custom-detail {
  width: calc(100% - 700px);
  border-left: 1px solid #d7d7d7;
  height: 100%;
  overflow: auto;
}

.status-choose {
  align-items: center;
  @media screen and (max-width: 1505px) {
    min-width: 340px;
  }
}
.state-filter {
  background-color: white;
  padding: 5px;
  margin-right: 9px;
  border: 1px solid #d9d9d9;
}
</style>
